import { client } from "./client";
import type {
  LoginRequest,
  LoginResult,
  PlatformUserVO,
  RegisterRequest,
} from "@/types";

function extractToken(authHeader: string | null | undefined): string {
  if (!authHeader) return "";
  return authHeader.startsWith("Bearer ") ? authHeader.slice(7) : authHeader;
}

export const authApi = {
  async login(body: LoginRequest): Promise<LoginResult> {
    const res = await client.post<PlatformUserVO>("/app/login", body);
    // JWT comes back in a response header, not the body.
    const header =
      (res.headers["authorization"] as string | undefined) ??
      (res.headers["Authorization"] as unknown as string | undefined);
    const token = extractToken(header);
    if (!token) {
      throw new Error("Login succeeded but no token was returned.");
    }
    return { token, user: res.data };
  },

  async register(body: RegisterRequest): Promise<string> {
    const res = await client.post<string>("/app/register", body);
    return res.data;
  },

  async checkEmail(email: string): Promise<string> {
    const res = await client.get<string>(`/app/users/check/${encodeURIComponent(email)}`);
    return res.data;
  },

  async logout(): Promise<void> {
    await client.put("/app/logout");
  },

  async forgotPassword(email: string): Promise<string> {
    const res = await client.get<string>(`/app/forgot-password/${encodeURIComponent(email)}`);
    return res.data;
  },

  async changePassword(oldPassword: string, newPassword: string): Promise<string> {
    const res = await client.post<string>("/app/pwd/new", { oldPassword, newPassword });
    return res.data;
  },

  async getUser(email: string): Promise<PlatformUserVO> {
    const res = await client.get<PlatformUserVO>(`/app/user/${encodeURIComponent(email)}`);
    return res.data;
  },
};
